import EnhancedTab from 'lib/designSystem/TabSimulation';
import BusinessInvoices from 'pages/BusinessProfile/SII/Components/BusinessInvoices';
import FactoringRequestsSent from 'pages/Finance/Components/Financing/Factoring/components/Sent';
import AutoEnrollment from 'pages/PruffConnect/Common/AutoEnrollment';
import PendingAccounts from 'pages/PruffConnect/Factoring/components/PendingAccounts';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState } from 'services/redux/store';

import CreditLineStatus from '../Common/CreditLineStatus';

const Factoring = () => {
  const auth = useSelector((state: RootState) => state.auth);
  const isAutoEnrolled = useMemo(() => auth.user?.autoEnrrolled, [auth.user]);
  const getAvailableTabs = () => {
    return [
      {
        label: 'Línea de Crédito',
        component: <CreditLineStatus productId="factoring" />,
        index: 0,
        path: 'creditLine',
      },
      {
        label: 'Mis Facturas',
        component: isAutoEnrolled ? <BusinessInvoices /> : <AutoEnrollment />,
        index: 1,
        path: 'invoices',
      },
      {
        label: 'Mis solicitudes',
        component: <FactoringRequestsSent />,
        index: 2,
        path: 'requests',
      },
      {
        label: 'Cuentas Pendientes',
        component: <PendingAccounts />,
        index: 3,
        path: 'pendingAccounts',
      },
    ];
  };

  const tabs = getAvailableTabs();

  const subPage = useParams<{
    page: string;
  }>();

  const startValue = tabs.findIndex((x: any) => x.path === subPage?.page);
  const navigate = useNavigate();

  const handleNavigation = (index: number) => {
    navigate(`/factoring/${tabs[index].path}`);
  };

  return (
    <div>
      <EnhancedTab
        title="Factoring"
        startValue={startValue}
        tabs={tabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default Factoring;
